import { CareersHeader, CareersPageContent } from "../components";

export function CareersPage() {
  return (
    <>
      <CareersHeader />
      <CareersPageContent />
      {/* <ApplyCareersForm /> */}
    </>
  );
}
